var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "hotkey",
          rawName: "v-hotkey",
          value: _vm.keymap,
          expression: "keymap"
        }
      ],
      attrs: { id: "app" }
    },
    [
      _vm.user != "" && _vm.user != undefined && _vm.user != null
        ? _c("div", { staticClass: "menu" }, [
            _c("div", { staticClass: "tabs" }, [
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "dropbtn",
                    attrs: { tabindex: "-1" },
                    on: {
                      click: function($event) {
                        return _vm.toggleDropdown("1")
                      }
                    }
                  },
                  [
                    _vm._v("File"),
                    _c("font-awesome-icon", {
                      staticClass: "arrow",
                      attrs: { icon: "chevron-down" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-content", attrs: { id: "drp_1" } },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "#/home" },
                        on: { click: _vm.removeDropdowns }
                      },
                      [_vm._v("Home")]
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.user != "" && _vm.user != undefined && _vm.user != null
                      ? _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href:
                                "https://accounts.ldpa.com/realms/master/account"
                            },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Account")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#/0201" },
                        on: { click: _vm.removeDropdowns }
                      },
                      [_vm._v("Signup")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#/0200" },
                        on: { click: _vm.removeDropdowns }
                      },
                      [_vm._v("Login")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function($event) {
                            return _vm.logout()
                          }
                        }
                      },
                      [_vm._v("Logout")]
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("103")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0208" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Permissions")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("85")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0207" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Logs")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#/0206" },
                        on: { click: _vm.removeDropdowns }
                      },
                      [_vm._v("LDPA Cloud")]
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("100")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0412" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Submit Troubleticket")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("87")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/downloadapp" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Download Mobile App")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("96")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/downloadcandidateapp" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Download App Candidate")]
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "dropbtn",
                    attrs: { tabindex: "-1" },
                    on: {
                      click: function($event) {
                        return _vm.toggleDropdown("2")
                      }
                    }
                  },
                  [
                    _vm._v("Job Orders"),
                    _c("font-awesome-icon", {
                      staticClass: "arrow",
                      attrs: { icon: "chevron-down" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-content", attrs: { id: "drp_2" } },
                  [
                    _vm.perms.includes("1")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0300" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Job Orders")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("44")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0310" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Scheduling")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("120")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0329" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Scheduling V2")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("1")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0318" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Port Stays")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("134")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0334" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Trips")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("18")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0305" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Vessels")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("55")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0311" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Vessel History")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("4")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0303" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Unassigned Documents")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("132")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0332" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Assign Document WO")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("132")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0335" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Approve Documents")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("14")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0400" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Add Job Order")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("31")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0401" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Add Vessel")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("34")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0402" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Add Document")]
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "dropbtn",
                    attrs: { tabindex: "-1" },
                    on: {
                      click: function($event) {
                        return _vm.toggleDropdown("3")
                      }
                    }
                  },
                  [
                    _vm._v("Invoicing"),
                    _c("font-awesome-icon", {
                      staticClass: "arrow",
                      attrs: { icon: "chevron-down" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-content", attrs: { id: "drp_3" } },
                  [
                    _vm.perms.includes("40")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0308" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Invoices")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("77")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0317" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Invoice Status")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("70")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0315" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("PO Numbers")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("83")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0319" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Contracts")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("72")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0407" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Add PO Number")]
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "dropbtn",
                    attrs: { tabindex: "-1" },
                    on: {
                      click: function($event) {
                        return _vm.toggleDropdown("4")
                      }
                    }
                  },
                  [
                    _vm._v("Times"),
                    _c("font-awesome-icon", {
                      staticClass: "arrow",
                      attrs: { icon: "chevron-down" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-content", attrs: { id: "drp_4" } },
                  [
                    _vm.perms.includes("33")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0307" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Employee Overview")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("3")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0302" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Employee Hours")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("99")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0326" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Timesheets")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("99")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0330" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Map")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("131")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0331" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Edit Employees")]
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "dropbtn",
                    attrs: { tabindex: "-1" },
                    on: {
                      click: function($event) {
                        return _vm.toggleDropdown("5")
                      }
                    }
                  },
                  [
                    _vm._v("Inventory"),
                    _c("font-awesome-icon", {
                      staticClass: "arrow",
                      attrs: { icon: "chevron-down" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-content", attrs: { id: "drp_5" } },
                  [
                    _vm.perms.includes("88")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0322" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Inventory")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("88")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0325" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Boxes")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("88")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0333" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Edit Box Items")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.perms.includes("89")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0410" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Add Inventory Item")]
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "dropbtn",
                    attrs: { tabindex: "-1" },
                    on: {
                      click: function($event) {
                        return _vm.toggleDropdown("6")
                      }
                    }
                  },
                  [
                    _vm._v("Reports"),
                    _c("font-awesome-icon", {
                      staticClass: "arrow",
                      attrs: { icon: "chevron-down" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-content", attrs: { id: "drp_6" } },
                  [
                    _vm.perms.includes("86")
                      ? _c("div", { staticClass: "dropdowngroup" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function($event) {
                                  return _vm.toggleDropdown("8", "6")
                                }
                              }
                            },
                            [
                              _vm._v("Dashboards"),
                              _c("font-awesome-icon", {
                                staticClass: "arrow",
                                attrs: { icon: "chevron-right" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdowngroup-content",
                              attrs: { id: "drp_8" }
                            },
                            _vm._l(_vm.dashboards, function(dashboard, index) {
                              return _c(
                                "a",
                                {
                                  attrs: { href: "#/0321?q=" + (index + 1) },
                                  on: { click: _vm.removeDropdowns }
                                },
                                [_vm._v(_vm._s(dashboard))]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("79")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0600" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Custom")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("78")
                      ? _c("div", { staticClass: "dropdowngroup" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function($event) {
                                  return _vm.toggleDropdown("7", "6")
                                }
                              }
                            },
                            [
                              _vm._v("Status"),
                              _c("font-awesome-icon", {
                                staticClass: "arrow",
                                attrs: { icon: "chevron-right" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdowngroup-content",
                              attrs: { id: "drp_7" }
                            },
                            _vm._l(_vm.statusgroups, function(
                              statusgroup,
                              index
                            ) {
                              return _c(
                                "a",
                                {
                                  attrs: { href: "#/0601" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setStatusGroup(index + 1)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(statusgroup))]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "dropbtn",
                    attrs: { tabindex: "-1" },
                    on: {
                      click: function($event) {
                        return _vm.toggleDropdown("9")
                      }
                    }
                  },
                  [
                    _vm._v("Tools"),
                    _c("font-awesome-icon", {
                      staticClass: "arrow",
                      attrs: { icon: "chevron-down" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-content", attrs: { id: "drp_9" } },
                  [
                    _vm.perms.includes("1")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0700" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Proxy Test")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("114")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0701" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Emails")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.perms.includes("117")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#/0328" },
                            on: { click: _vm.removeDropdowns }
                          },
                          [_vm._v("Website HTML")]
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "page-name" }, [
                _vm._v(_vm._s(_vm.$route.name))
              ])
            ]),
            _vm._v(" "),
            _vm.user != "" && _vm.user != undefined && _vm.user != null
              ? _c(
                  "p",
                  {
                    staticClass: "logged",
                    on: {
                      click: function($event) {
                        return _vm.navigate("0205")
                      }
                    }
                  },
                  [_vm._v("Logged in as " + _vm._s(_vm.user))]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 884
// module chunks = 0